module.exports = __webpack_public_path__ + "9fe01160a5e966ba7cbda178524b5de0.png";